export default __webpack_public_path__ + "static/media/pantry1-afterE-1024w.98ef9a67.png";